export default __webpack_public_path__ + "static/media/chapterspic2.a86fae9b.png";